import { type Layout, sections, singleRow, stack } from "owa-acui";
import type { TabScalingAndLayoutConfig } from "owa-mail-ribbon-store-shared-types";
import { type MailRibbonControlId, type MailRibbonGroupId, type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { RibbonControlId } from "owa-ribbon-ids";
import type { ReadOnlyRibbonControlDefProps } from "./RibbonControlDefinitionProps";
import { getReadRibbonId } from "./getReadRibbonId";
import shouldPromoteNotJunk, { type ReportPromotionTabId } from "./shouldPromoteNotJunk";

export const promotedReportControlIds: RibbonControlId[] = [
    535,
    657,
    547,
];

/**
 * Promotion only applies to uncustomized (default) layouts, so the Report group is moved as-is
 * and its existing controls are reordered to lead with Not junk.
 */
export default function getPromotedReportRibbonConfig(tabConfig: TabScalingAndLayoutConfig, props: ReadOnlyRibbonControlDefProps, tabId: ReportPromotionTabId): TabScalingAndLayoutConfig {
    const reportGroup = tabConfig.layout.find(group => group.groupId === 197);
    if (!reportGroup || !shouldPromoteNotJunk(props, tabId)) {
        return tabConfig;
    }
    
    const layout = tabConfig.layout.filter(group => group !== reportGroup);
    const insertionIndex = tabId === 8
        ? 0
        : layout.findIndex(group => group.groupId === 116) + 1;
    const controlIds = [
        ...promotedReportControlIds.filter(id => reportGroup.controlIds.includes(id)),
        ...reportGroup.controlIds.filter(id => !promotedReportControlIds.includes(id)),
    ];
    layout.splice(insertionIndex, 0, { ...reportGroup, controlIds });
    
    return { ...tabConfig, layout };
}

/**
 * MLR layouts for the Report group. When promoted, Not junk leads the full-size layout.
 */
export function getReportGroupLayouts(props: ReadOnlyRibbonControlDefProps, tabId: ReportPromotionTabId): Layout[] {
    const { itemId } = props;
    const reportSplitId = getReadRibbonId(657, itemId).toString();
    const phishingId = getReadRibbonId(547, itemId).toString();
    const junkNotJunkId = getReadRibbonId(535, itemId).toString();
    
    const fullLayout = shouldPromoteNotJunk(props, tabId)
        ? singleRow(junkNotJunkId, reportSplitId, phishingId)
        : singleRow(reportSplitId, junkNotJunkId, phishingId);
    
    return [
        sections(fullLayout),
        sections(singleRow(reportSplitId, stack(junkNotJunkId, phishingId))),
    ];
}
